// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"e527ec40","496":"8d8889c6","647":"85685ce4"}[chunkId] + ".chunk.js";
};